import { comeData, SLOT_RESI, type MagazzinoRiepilogo } from "../api";

const CHIP =
  "inline-flex items-center rounded-md px-1.5 py-0.5 text-[11.5px] font-semibold leading-tight text-ink whitespace-nowrap";

function giornoBreve(iso: string): string {
  return comeData(iso).toLocaleDateString("it-IT", {
    weekday: "short",
    day: "numeric",
  });
}

type Props = {
  magazzini: MagazzinoRiepilogo[];
  selezionato: string | null;
  onScegli: (slot: string) => void;
};

export function MagazziniLista({ magazzini, selezionato, onScegli }: Props) {
  return (
    <nav aria-label="Magazzini" className="flex flex-col gap-1.5">
      <p className="mb-1 ml-0.5 text-[12px] font-extrabold text-ink">Magazzini</p>
      {magazzini.map((m) => (
        <button
          key={m.slot}
          type="button"
          onClick={() => onScegli(m.slot)}
          aria-current={selezionato === m.slot ? "true" : undefined}
          className={`rounded-xl border bg-card px-3 py-2.5 text-left text-ink ${
            selezionato === m.slot
              ? "border-line-2 shadow-[inset_3px_0_0_rgb(var(--om-accent))]"
              : "border-line hover:border-line-2"
          }`}
        >
          <span className="flex items-center justify-between gap-2 text-[13.5px] font-bold">
            {m.etichetta}
            {m.mancanti.includes("indirizzo") ? (
              <span className={`${CHIP} bg-red-soft`}>indirizzo da completare</span>
            ) : m.mancanti.includes("telefono") ? (
              <span className={`${CHIP} bg-red-soft`}>manca telefono</span>
            ) : null}
          </span>
          <span className="block text-[12px]">{m.citta || "—"}</span>
          <span className="mt-1.5 flex flex-wrap gap-1">
            {m.da_prenotare > 0 ? (
              <span className={`${CHIP} bg-amber-soft`}>
                {m.da_prenotare} da prenotare · {m.colli_da_prenotare}{" "}
                {m.colli_da_prenotare === 1 ? "collo" : "colli"}
              </span>
            ) : (
              <span className={`${CHIP} bg-paper-2`}>nessun pronto</span>
            )}
            {m.prossimo && (
              <span className={`${CHIP} bg-green-soft`}>
                {giornoBreve(m.prossimo.data_ritiro)} · {m.prossimo.codice ?? "da verificare"}
              </span>
            )}
            {m.mancato && (
              <span className={`${CHIP} bg-red-soft`}>
                ritiro {m.mancato.parziale ? "parziale" : "mancato"} ·{" "}
                {giornoBreve(m.mancato.data_ritiro)}
              </span>
            )}
            <span
              className={`${CHIP} ${m.impostazioni.automatico ? "bg-green-soft" : "bg-paper-2"}`}
            >
              {m.impostazioni.automatico
                ? `auto ${[m.impostazioni.ora_automatico_mattina, m.impostazioni.ora_automatico].filter(Boolean).join(" · ")}`
                : "manuale"}
            </span>
          </span>
        </button>
      ))}
      <p className="mb-1 ml-0.5 mt-3 text-[12px] font-extrabold text-ink">Dai clienti</p>
      <button
        type="button"
        onClick={() => onScegli(SLOT_RESI)}
        aria-current={selezionato === SLOT_RESI ? "true" : undefined}
        className={`rounded-xl border bg-card px-3 py-2.5 text-left text-ink ${
          selezionato === SLOT_RESI
            ? "border-line-2 shadow-[inset_3px_0_0_rgb(var(--om-accent))]"
            : "border-line hover:border-line-2"
        }`}
      >
        <span className="block text-[13.5px] font-bold">Resi</span>
        <span className="block text-[12px]">Ritiri prenotati dal dialog del reso</span>
      </button>
    </nav>
  );
}
